angular.module('unergie.main')
.controller('casesCtrl', ($scope, $state, TableGeneratorService, BoFeaturesService, ApiUser, AlertManager, ErrorCatcher, DataAccessSearch, DataAccess, ReferencesService, b2g) => {
    $scope.b2g = b2g
    $scope.accessSge = BoFeaturesService.isFeatureOn('accessSge')
    $scope.canSeeJira = BoFeaturesService.isFeatureOn('canSeeJira')
    $scope.canChooseIdGrdContract = BoFeaturesService.isFeatureOn('canChooseIdGrdContract')

    $scope.objectCodeFamilies = [
        { id: 'AME,HDM', title: 'Collecte de données' },
        { id: 'F130B,CFN,F120B,MES,F100B,RIC,F140,RIF,PMS,F800B,F860,F820,MBP,F130A,F880,F870,F840', title: 'Ajout / retrait de PDL' },
        { id: 'CST,F180,RPI,CPT,M007,CIC,CCF,F185', title: 'Modification techniques / contractuelles' },
        { id: 'F200B,M002,NA,SAI,F420C,RET,M013,F460B,F940B,F920,F960,F610,RST', title: 'Réclamations / autres' },
        { id: 'M008,TIA,F365,F360', title: 'Index' },
    ]

    $scope.cases = {
        refreshing: false,
        show: {},
        columns: {
            'id': { label: 'Id', mode: 'search_wildcard', length: 8 },
            'object_code': { label: 'Code', mode: 'search_wildcard' },
            'option_code': { label: 'Code option', mode: 'hidden', translateCsv: 'option_code' }, // translateCsv force l'inclusion dans le CSV même si hidden
            'id_prm': { label: 'PRM', mode: 'search_wildcard', length: 14 },
            'id_contract': { label: 'Contrat', mode: $scope.b2g ? 'hidden' : 'search_wildcard', length: 9 },
            'contractElec.account.fullname': { label: 'Client', mode: 'search_wildcard' },
            'creation_ts': { label: 'Création', mode: 'search_date' },
            'first_milestone': { label: 'Début', mode: 'filter_only' },
            'modification_ts': { label: 'Mis à jour', mode: 'search_date' },
            'case_follow_up_view.shown_status': { label: 'Status', mode: $scope.b2g ? 'hidden' : 'search_wildcard' },
            'status_label': { label: 'Etat', mode: 'search_wildcard' },
            'reject_code': { label: 'Code Rejet', mode: 'search_wildcard' },
            'login_caller': { label: 'Login', mode: $scope.b2g ? 'hidden' : 'search_wildcard' },
            'creator_account.fullname': { label: 'Demandeur BO', mode: $scope.b2g ? 'hidden' : 'search_wildcard' },
            'id_case_recla': { label: 'Affaire Annulation', mode: $scope.b2g ? 'hidden' : 'search_wildcard' },
            'object_label': { label: 'Libellé affaire', mode: 'search_wildcard' },
            'option_label': { label: 'Libellé option', mode: 'hidden', translateCsv: 'option_label' },
            'reject_label': { label: 'Libellé rejet', mode: 'hidden' },
            'reject_comment': { label: 'Commentaire rejet', mode: 'hidden' },
            'status_code': { label: 'Statut', mode: 'hidden' },
            'cancel_status': { label: 'Statut annulation', mode: 'hidden' },
            'cancel_ts': { label: 'Date annulation', mode: 'hidden' },
            'issue_description': { label: 'Description anomalie', mode: 'hidden' },
            'issue_response': { label: 'Réponse anomalie', mode: 'hidden' },
        },
    }

    if ($scope.b2g) {
        $scope.cases.columns['contractElec.account.brand'] = { label: 'Adhérent', mode: 'search_wildcard' }
    }

    if ($scope.canChooseIdGrdContract) {
        $scope.cases.columns.id_grd_contract = { label: 'Contrat GRD', mode: 'search_wildcard', length: 8 }
    }

    // LABEL EDITION
    $scope.editReclaCaseField = {
        new_id_case_recla: {
            label: 'Affaire de réclamation',
            type: 'text',
        },
    }

    $scope.to_follow = {
        ids: [{ id: 'true', label: 'À suivre' },
            { id: 'false', label: 'Autres' },
            { id: undefined, label: 'Toutes' }],
        chosen: 'true',
    }

    $scope.statuses = {
        ids: [{ id: 'COURS', label: 'En cours' },
            { id: 'ERR', label: 'En erreur' },
            { id: undefined, label: 'Toutes' }],
        chosen: undefined,
    }

    $scope.refreshPrmTemplate = {
        expl: {
            label: `Pour rappel ce bouton ne rafraîchit que le statut de l'affaire et non celui du contrat`,
            type: 'label',
        },
    }

    const transformData = function (data) {
        data.forEach((caseDatum) => {
            if (caseDatum.contractElec && caseDatum.contractElec.account) {
                caseDatum.contractElec.account.fullname = `${caseDatum.contractElec.account.givenname} ${caseDatum.contractElec.account.sn}`
            }
            if (caseDatum.milestones) {
                caseDatum.first_milestone = _.min(_.map(caseDatum.milestones, (milestone) => { return milestone.date_time }))
            }
            if (caseDatum.creator_account) {
                caseDatum.creator_fullname = `${caseDatum.creator_account.givenname} ${caseDatum.creator_account.sn}`
            }
        })
        return data
    }

    $scope.refresh = () => {
        const searchFilters = {
            search: {
                id_grd_contract: $scope.grdContracts.chosen,
            },
            orderBy: $scope.b2g ? '-modification_ts' : 'creation_ts',
        }
        if (!$scope.b2g) {
            searchFilters.search['case_follow_up_view.to_follow'] = $scope.to_follow.chosen
        }
        if ($scope.statuses.chosen === 'ERR') {
            searchFilters.notnull = ['reject_code']
            searchFilters.gte = [`modification_ts=${moment().subtract(30, 'days').format('YYYY-MM-DD')}`]
        } else if ($scope.statuses.chosen === 'COURS') {
            searchFilters.search.status_code = 'COURS'
        }
        TableGeneratorService.getTable(
            $scope.cases,
            'cases', 'contractElec.account,milestones,interventions,creator_account,case_follow_up_view',
            transformData,
            searchFilters,
        )
    }

    $scope.getStatusCodeColorClass = (status_code, last_milestone_code, reject_code) => {
        if (last_milestone_code === 'CPNR' || reject_code) {
            return 'darkish-pink'
        }
        return _.defaultTo({ COURS: 'orange', TERMN: 'dark-green', ANNUL: 'bluegrey' }[status_code], 'bluegrey')
    }
    $scope.getStatusCodeBorderLeftColorClass = (status_code, last_milestone_code, reject_code) => `border-left-${$scope.getStatusCodeColorClass(status_code, last_milestone_code, reject_code)}`

    $scope.getCriticalityColorClass = (criticality) => _.defaultTo({ WARNING: 'orange', INFO: 'dark-green', ERROR: 'darkish-pink', WAITING: 'bluegrey' }[criticality], 'bluegrey')


    $scope.expandCase = function (caseDatum) {
        caseDatum.expanded = !caseDatum.expanded
    }

    $scope.refreshCaseData = (c) => {
        c.refreshingData = true
        return DataAccessSearch({}).searchPaginated({ resource: 'cases', id: c.id, withRelated: 'contractElec.account,milestones,interventions,creator_account,case_follow_up_view' }).$promise
        .then((caseResult) => _.assign(c, transformData(caseResult.results)[0])).catch(ErrorCatcher)
        .finally(() => {
            c.refreshingData = false
        })
    }

    $scope.canCancelCase = (c) => c && ['COURS'].includes(c.status_code) && (c.cancel_status === null) && c.id_grd_contract && BoFeaturesService.isFeatureOn('canCancelCase')

    $scope.cancelCase = (c) => {
        c.cancellingCase = true
        return ApiUser.cancelCase({ idCase: c.id }, {}).$promise
        .then((result) => { AlertManager.success(`Annulation demandée : ${result.message}`, 6000) })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshCaseData(c)
            c.cancellingCase = false
        })
    }

    $scope.canRefreshCase = () => BoFeaturesService.isFeatureOn('canRefreshCase')

    $scope.refreshCase = function (c) {
        return ApiUser.refreshCase({ idCase: c.id }, {}).$promise
        .then((result) => { AlertManager.success(`Affaire raffraichie : ${c.id}`, 6000) })
        .catch(ErrorCatcher)
        .finally(() => $scope.refreshCaseData(c))
    }

    $scope.markProcessed = (c) => {
        return DataAccess.updateCase({ id: c.id }, { internal_status: 'PROCESSED' }).$promise
        .then((result) => { AlertManager.success(`Affaire marquée comme traitée : ${c.id}`, 6000) })
        .catch(ErrorCatcher)
        .finally(() => $scope.refreshCaseData(c))
    }

    $scope.markIgnored = (c) => {
        return DataAccess.updateCase({ id: c.id }, { internal_status: 'IGNORED' }).$promise
        .then((result) => { AlertManager.success(`Affaire marquée comme ignorée : ${c.id}`, 6000) })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshCaseData(c)
        })
    }

    $scope.addReclaCase = (c) => {
        return DataAccess.updateCase({ id: c.id }, { id_case_recla: c.new_id_case_recla }).$promise
        .then((result) => {
            if (c.new_id_case_recla) {
                AlertManager.success(`Affaire de réclamation ajoutée : ${c.new_id_case_recla}`, 6000)
            } else {
                AlertManager.success(`Affaire de réclamation supprimée`, 6000)
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshCaseData(c)
        })
    }

    $scope.grdContracts = {
        ids: [],
        chosen: undefined,
    }

    ReferencesService.getRef('id-grd-contracts', true).then((mapping) => {
        $scope.grdContracts.ids = _.map(mapping, (elem) => ({ id: elem.id, label: elem.id }))
        if ($scope.canChooseIdGrdContract) {
            $scope.grdContracts.ids.push({ id: undefined, label: 'Tous' })
            $scope.to_follow.chosen = undefined
        }
        $scope.refresh()
    })


    $scope.isActive = (state) => $state.is(state)
})
